import { render } from "./questionList.vue?vue&type=template&id=63ce5cd2&scoped=true"
import script from "./questionList.vue?vue&type=script&lang=js"
export * from "./questionList.vue?vue&type=script&lang=js"

import "./questionList.vue?vue&type=style&index=0&id=63ce5cd2&lang=less&scoped=true"
import "./questionList.vue?vue&type=style&index=1&id=63ce5cd2&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ce5cd2"]])

export default __exports__